import React from 'react';
import { Clock, ArrowLeft, Mail, MapPin, FileText } from 'lucide-react';

const Impressum = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-slate-950 text-white font-sans">
      {/* Navigation */}
      <nav className="fixed w-full z-50 bg-slate-950/80 backdrop-blur-md border-b border-slate-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center space-x-3">
              <div className="bg-rose-600 p-2 rounded-xl">
                <Clock className="w-6 h-6 text-white" />
              </div>
              <span className="text-2xl font-black tracking-tighter text-white uppercase">PRESENTLY</span>
            </div>
            <button
              onClick={onBack}
              className="flex items-center space-x-2 text-slate-400 hover:text-white transition-colors group"
            >
              <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
              <span className="text-sm font-bold uppercase tracking-widest">Back</span>
            </button>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-24">

        {/* Header */}
        <div className="mb-12">
          <div className="inline-flex items-center space-x-2 bg-slate-800 border border-slate-700 px-4 py-2 rounded-full mb-6">
            <FileText className="w-3.5 h-3.5 text-rose-500" />
            <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">Legal Disclosure · §5 TMG</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-black tracking-tighter text-white mb-4">
            Impressum
          </h1>
          <p className="text-slate-400 font-medium">
            Pflichtangaben gemäß § 5 TMG (Telemediengesetz)
          </p>
        </div>

        <div className="space-y-8">

          {/* Responsible Party */}
          <Section title="Angaben gemäß § 5 TMG">
            <InfoRow icon={<MapPin className="w-4 h-4 text-rose-500 mt-0.5 flex-shrink-0" />}>
              <div>
                <p className="font-bold text-white">Samuel Robin Gera</p>
                <p className="text-slate-400">Presently SaaS</p>
                <p className="text-slate-400 mt-1">Breslauer Str. 16</p>
                <p className="text-slate-400">91074 Herzogenaurach</p>
                <p className="text-slate-400">Deutschland</p>
              </div>
            </InfoRow>
          </Section>

          {/* Contact */}
          <Section title="Kontakt">
            <InfoRow icon={<Mail className="w-4 h-4 text-rose-500 mt-0.5 flex-shrink-0" />}>
              <div>
                <p className="text-slate-300 text-sm font-medium mb-0.5">E-Mail</p>
                <a
                  href="mailto:samuelrobingera@gmail.com"
                  className="text-rose-400 hover:text-rose-300 font-bold transition-colors"
                >
                  samuelrobingera@gmail.com
                </a>
              </div>
            </InfoRow>
          </Section>

          {/* EU Dispute Resolution */}
          <Section title="EU-Streitschlichtung">
            <p className="text-slate-400 font-medium leading-relaxed">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-rose-400 hover:text-rose-300 transition-colors break-all"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              .
            </p>
            <p className="text-slate-400 font-medium leading-relaxed mt-3">
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </Section>

          {/* Consumer Dispute */}
          <Section title="Verbraucherstreitbeilegung / Universalschlichtungsstelle">
            <p className="text-slate-400 font-medium leading-relaxed">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </Section>

          {/* Liability for Content */}
          <Section title="Haftung für Inhalte">
            <p className="text-slate-400 font-medium leading-relaxed">
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten
              nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
              Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
              Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
              rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="text-slate-400 font-medium leading-relaxed mt-4">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
              allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch
              erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
              Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
              entfernen.
            </p>
          </Section>

          {/* Liability for Links */}
          <Section title="Haftung für Links">
            <p className="text-slate-400 font-medium leading-relaxed">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
              Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
              übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
              Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
              Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
              Zeitpunkt der Verlinkung nicht erkennbar.
            </p>
          </Section>

          {/* Copyright */}
          <Section title="Urheberrecht">
            <p className="text-slate-400 font-medium leading-relaxed">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
              dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
              der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
              Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
              sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
            <p className="text-slate-400 font-medium leading-relaxed mt-4">
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die
              Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
              gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam
              werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
              Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
          </Section>

          {/* Last Updated */}
          <div className="pt-6 border-t border-slate-800">
            <p className="text-slate-600 text-xs font-bold uppercase tracking-widest">
              Stand: Juni 2026
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div className="bg-slate-900 border border-slate-800 rounded-[28px] p-8">
    <h2 className="text-xs font-black uppercase tracking-widest text-rose-500 mb-4">{title}</h2>
    {children}
  </div>
);

const InfoRow = ({ icon, children }) => (
  <div className="flex items-start space-x-3">
    {icon}
    {children}
  </div>
);

export default Impressum;
